export { Cog as default } from './Cog';
